import React, { Component } from 'react';
import NotificationCreator from '../notification-creator/notification-creator';
import * as microsoftTeams from "@microsoft/teams-js";
import { connect } from 'react-redux';
import { createNotification } from '../../../actions/notification.actions';
import { Header, Icon, Segment } from 'semantic-ui-react';
import { CONFIG } from '../../../helper/config';
import { storeSessionId } from '../../../actions/view.actions';
import { ChartConfigInfo } from '../../../modal/filters';
import _ from 'lodash';

interface IProps {
    notification_msg: string;
    is_license_expire: boolean;
    notify_me_from_inside?: boolean;
    teams_default_view: ChartConfigInfo;
    sessionId:string;
    createNotification: (info: any, auth_token: string) => void;
    storeSessionId:(arg:string) => void;
    sequence_id?: any;
    file_name?: any;
    template_config?:any;
    team_context?:any;
    webAppData?:any;
}

interface IState {
    is_submit: boolean;
    auth_token: string;
    teams_context: any;
}

/**
 * CreateNotification component.
 *
 * This component manages the lifecycle of creating notifications in both
 * Microsoft Teams and WebApp contexts.
 *
 * Features:
 * - Initializes and retrieves Teams or WebApp context.
 * - Fetches authentication tokens.
 * - Constructs and submits notifications via Redux actions.
 * - Handles error and success states gracefully.
 *
 * It renders either a success/failure state or the NotificationCreator form.
 */
export class CreateNotification extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            is_submit: false,
            auth_token: '',
            teams_context: {}
        }
    }

/**
 * Called when the component has been mounted.
 * For Microsoft Teams:
 * - Initializes the Teams app and notifies success if not inside notification.
 * - Retrieves and logs context information like chatId, channelId, groupId, userObjectId, meetingId, and tenantId.
 * - Obtains auth token and sets the component state with Teams context and auth token.
 * - Stores a session ID if it doesn't exist.
 * - Handles errors by setting is_submit state to true.
 * For WebApp:
 * - Listens for message events to receive WebApp data.
 * - Extracts token and user information from the event data.
 * - Sets the component state with auth token and context information.
 * - Stores a session ID.
 */
    componentDidMount() {
        const query_params = window.location.search.split('?')[1];
        const isWebApp = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[5]:"";
        const port_no: any = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[0] : '';
        const file_name: any = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[1] : '';
        console.log('port No', port_no);
        console.log('File Name', file_name);
        if(isWebApp!==CONFIG.WEBAPP){
        let teams_context: any = {};
        if (!this.props.notify_me_from_inside) {
            microsoftTeams.app.initialize();
            microsoftTeams.app.notifySuccess();
        }
        let comp_ref = this;
        microsoftTeams.app.getContext().then((context) => {
            console.log("context", context);
            teams_context.chatId = (context.chat?.id && context.chat.id !== '') ? context.chat.id : '';
            teams_context.channelId = (context.channel?.id && context.channel?.id !== '') ? context.channel?.id : '';
            teams_context.groupId = context.team?.groupId;
            teams_context.userObjectId = context.user?.id;
            teams_context.meetingId = context.meeting?.id;
            teams_context.tid = context.user?.tenant?.id;
            teams_context.teams_channel_id = context.channel?.id;
            microsoftTeams.authentication.getAuthToken().then( (token: string) => {
                    comp_ref.setState({ teams_context: teams_context, auth_token: token });
                    if(!this.props.sessionId){
                        let session_id = new Date().toString();
                          this.props.storeSessionId(session_id)
                    }
                }).catch((error) => {
                    console.error("error", error);
                    comp_ref.setState({ is_submit: true });
            })
            }).catch((error) => {
                console.error("error", error);
                comp_ref.setState({ is_submit: true });
            })
    }else{
        let webAppData;
        const handleMessage = (event) => {
            if (event.origin !== event?.data?.parentUrl) return;
            webAppData = { ...event.data };
        
            const token = webAppData.token
            const info = {
              "va_id": query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[2] : '',
              "port_no": port_no,
              "user_id": webAppData.aad_object_id,
              "user_name": webAppData.email,
              "tenant_id": webAppData.tenantId,
              "file_name": file_name,
              "channelId": "msteams"
            }
            this.setState({
              auth_token: token,
              teams_context:info
            })
            let session_id = new Date().toString();
            this.props.storeSessionId(session_id)
        };
        window.addEventListener('message', handleMessage);
      } 
    }

    /**
     * Creates a notification using the provided notification information.
     * Sets the state to indicate submission status.
     * Retrieves necessary parameters from props and state.
     * Constructs the notification object with relevant data.
     * Calls the createNotification action with the constructed notification object and auth token.
     *
     * @param {Object} notification_info - The information for creating the notification.
     */
    private createNotification = (notification_info: any) => {
        this.setState({ is_submit: true });
        let { notify_me_from_inside, sequence_id, file_name, teams_default_view, template_config, team_context } = this.props;
        let {teams_context} = this.state;
        if (notify_me_from_inside) {
            notification_info.notify_me_from_inside = notify_me_from_inside;
            notification_info.sequence_id = sequence_id;
            notification_info.img = (file_name && file_name !== '') ? file_name : notification_info.img;
            if(template_config && !_.isEqual(template_config.default_template_view, teams_default_view)){
                let chart_config = JSON.parse(JSON.stringify(template_config.chart_config));
                let index = chart_config.findIndex(cc => cc.chart_id === teams_default_view.chart_id);
                if(index !== -1){
                    chart_config[index] = JSON.parse(JSON.stringify(teams_default_view));
                }
                notification_info.template_config_keys_to_update = {chart_config:chart_config, default_template_view: teams_default_view};
            }
        }
        const query_params = window.location.search.split('?')[1];
        notification_info = {

            channelId: "msteams",
            platform: teams_context.userObjectId ? "teams": "webapp",
            from: {
              id: teams_context.userObjectId || teams_context?.user_id || team_context?.user_id,
              name: "Beagle",
              aadObjectId: teams_context.userObjectId || teams_context?.user_id || team_context?.user_id
            },
            conversation: {
              conversationType: query_params?.split(CONFIG.URLQUERYPARAMSEPERATOR)[4] || '',
              tenantId: teams_context.tid || teams_context.tenant_id || team_context?.tenant_id,
              id: notification_info.conversation_id
            },
            tenant_id:teams_context.tid || teams_context.tenant_id || team_context.tenant_id,
            channelData: {
              tenant: {
                id:teams_context.tid || teams_context.tenant_id || team_context.tenant_id,
              }
            },
            value:{
                data: notification_info
            },
            user_id: teams_context?.user_id? teams_context?.user_id : team_context?.user_id
        }
        this.props.createNotification(notification_info, this.state.auth_token ? this.state.auth_token:this.props.webAppData.token);
    }

    /**
     * Renders the component based on the current state and props.
     * If the license has expired, it displays a message.
     * If the notification was successful, it shows a success icon.
     * If there was an error, it shows an error message.
     * Otherwise, it renders the NotificationCreator component for creating notifications.
     */
    render() {
        const { notification_msg } = this.props;
        const { is_submit, teams_context } = this.state;
        if (this.props.is_license_expire) {
            return <Segment placeholder textAlign="center" size="large" content={CONFIG.LICENSE_EXPIRE} />
        } else if (notification_msg === CONFIG.NOTIFICATION.SUCCESS && is_submit) {
            return <Segment className='notification-sucess-segment' placeholder textAlign='center' >
                <Icon name='check circle' size='massive' color='green' />
            </Segment>
        } else if (notification_msg.trim() !== '' && notification_msg !== CONFIG.NOTIFICATION.SUCCESS && is_submit) {
            return <Segment className='notification-sucess-segment' placeholder textAlign='center' >
                <Icon name='times circle' size='massive' color='red' />
                <Header as='h4' content={notification_msg} />
            </Segment>
        } else {
            return (<>
                {(is_submit) ? null : <NotificationCreator teams_context={Object.keys(teams_context).length>0 ? teams_context:this.props.team_context}
                    is_create_notification={true}
                    saveNotification={this.createNotification} />}
            </>);
        }
    }
}

/**
 * Maps the relevant portions of the application state to props for the component.
 *
 * Retrieves the notification message, license expiration status, teams default view, and session ID from the state.
 * 
 * @param {Object} state - The state of the application.
 * @returns {Object} A props object containing the notification message, license expiration status, teams default view, and session ID.
 */
const mapStateToProps = (state: any) => ({
    notification_msg: state.notificationState.notification_msg,
    is_license_expire: state.viewState.is_license_expire,
    teams_default_view: state.cardLibraryState.teams_default_view,
    sessionId:state.viewState.sessionId
});

export default connect(mapStateToProps, { createNotification,storeSessionId })(CreateNotification);